import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';

import SignatureCanvas from 'react-signature-canvas';

class CheckoutSignature extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading             : false,

            signed              : false,
            signature           : null,
            agreementHtml       : null,

            pointCount          : 0,
        };

        this.save = this.save.bind(this);
        this.onSignatureEnd = this.onSignatureEnd.bind(this);
        this.isValid = this.isValid.bind(this);
    }


    onSignatureEnd() {
        this.setState({
            pointCount : this.refs.Signature.toData().reduce((c,a) => c + a.length, 0)
        });
    }

    save() {

        if (this.state.loading || !this.isValid())
            return;

        this.setState({ loading : true });
        AjaxPromises.POST(GuestEndPoints.SAVE_CHECKOUT_SIGNATURE, UserStore.getApiData({
            ShipmentId : this.props.ShipmentId,
            Signature : this.refs.Signature.toDataURL('image/png').split(',')[1]
        })).then(res => {

            if (res.Result) {
                this.setState({
                    signed: true,
                    loading : false
                });

                if(this.props.onSave) {
                    this.props.onSave();
                }
                NotificationActions.success('Signature saved')
            } else {
                this.setState({
                    loading : false,
                });

                NotificationActions.error('Error saving signature')
            }
        });
        
    }

    isValid() {
        return this.state.pointCount > 30;
    }

    render() {
        return (
            <div style={{
                height: '90%'
            }}>
                <SignatureCanvas
                            penColor='black'
                            ref='Signature'
                            canvasProps={{className: 'view-policy__canvas'}}
                            onEnd={this.onSignatureEnd} />
                <br />
                <div className={'view-policy__buttons'}>
                    
                    <div
                        class={'btn-green ' + (!this.isValid() ? 'btn-green__disabled' : '')}
                        style={{'marginRight':20}}
                        onClick={this.save}>
                        { !this.state.loading && 'SAVE' }
                        { this.state.loading && <i className='fa fa-spinner fa-pulse' />  }
                    </div>
                    
                    
                    <div
                        class="btn-green"
                        onClick={() => {
                            this.refs.Signature.clear();
                            this.setState({ pointCount : 0 });
                        }}>
                        CLEAR
                    </div>
                </div>
                
            </div>
        );
    }
}

export default CheckoutSignature;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutSignature.react.jsx